import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../vendor/gsap-bonus-umd/SplitText';
import easesCustom from '../fx/CustomEases';
gsap.registerPlugin(ScrollTrigger,SplitText);

export default class FxModule extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.blocks = this.DOM.view.querySelector('.js-block')
    this.DOM.bullet = this.DOM.view.querySelector('.fxBullet')
    this.DOM.desc = this.DOM.view.querySelector('.fxDesc p')
    this.DOM.blockA = this.DOM.view.querySelectorAll('.js-blockA')
    this.DOM.blockB = this.DOM.view.querySelectorAll('.js-blockB')
    this.DOM.cache = this.DOM.view.querySelectorAll('.js-cacheseo')
    //
    this.FX  = {}
    this.FX.desc = new SplitText(this.DOM.desc,{ type:'lines',lineThreshold:.1,reduceWhiteSpace:false })
    this.FX.descChildren = new SplitText(this.DOM.desc,{ type:'lines',lineThreshold:.1,linesClass:'tw-overflow-hidden',reduceWhiteSpace:false })
    // this.DOM.desc.parent.classList.add('is-ready')
    //! Fns
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add(()=>{
      gsap.set(this.DOM.cache, { autoAlpha:0 })
    })
    .add([
      gsap.fromTo(
        this.DOM.bullet,
        {
          scale:0
        },
        {
          scale:1,
          ease:'quint.inOut',
          duration:.8,
        }
      ),
      gsap.fromTo(
        this.FX.desc.lines,
        {
          y:'150%'
        },
        {
          y:0,
          ease:easesCustom.quart,
          duration:.8,
          stagger:.1
        }
      )
    ])
    .add([
      gsap.fromTo(
        this.DOM.blockA,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:'cubic.inOut',
          duration:1.2,
        }
      )
    ],'-=1')
    .add([
      gsap.fromTo(
        this.DOM.blockB,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:'cubic.inOut',
          duration:1.2,
        }
      )
    ],'-=1')

  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 50%',
    })
  }

  unmount()
  {
    this.st.kill(true)
  }
}
